/**
 * @file Share
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */
import PropTypes from "prop-types";
import useIsClientHydrated from "../../hooks/useIsClientHydrated";

/**
 *  The Share component.
 *
 * Share tools.
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the Share component
 */
const Share = ({ path = "" }) => {
    const isClientHydrated = useIsClientHydrated();

    return (
        <div className="share" data-testid="share">
            <h2 className="a11y">Social Sharing</h2>
            <div className="viafoura">
                {isClientHydrated && (
                    <div
                        className="vf-widget vf-share-bar-default"
                        data-testid="vf-share-bar"
                        data-widget="sharebar"
                        data-button-view="false"
                        data-path={path}
                        data-show-labels="true"
                        data-show-counters="false"
                        data-show-total="false"
                    ></div>
                )}
            </div>
        </div>
    );
};

Share.propTypes = {
    path: PropTypes.string,
};

export default Share;
